import * as React from 'react';
import { observer } from 'mobx-react';
import { Notice, Separator } from '@teliaee/design-system';
import useStores from '../stores/UseStores';
import NoticeAuthUpgrade from './NoticeAuthUpgrade';

interface LoginInfoNoticeProps {
  showAuthUpgradeNotice: boolean;
}

const LoginInfoNotice = ({ showAuthUpgradeNotice }: LoginInfoNoticeProps): React.JSX.Element | null => {
  const {
    routeStore: { decodedParams },
    translateStore: { hasTranslation, translate },
  } = useStores();

  const customLoginInfoNoticeTranslationKey = decodedParams.customLoginInfoNoticeTranslationKey;
  const hasCustomNotice = typeof customLoginInfoNoticeTranslationKey === 'string' && hasTranslation(customLoginInfoNoticeTranslationKey);

  if (!hasCustomNotice) {
    return showAuthUpgradeNotice ? <NoticeAuthUpgrade /> : null;
  }

  return (
    <>
      <Notice>{translate(customLoginInfoNoticeTranslationKey)}</Notice>
      <Separator spacing="small" color="invisible" />
    </>
  );
};

export default observer(LoginInfoNotice);
